import { Component, Input, SimpleChanges } from '@angular/core';
import { AnleggMaaned } from 'src/app/services/forbruk/forbruk.types';
import { toRoundNumber } from '../../../forbruk/forbrukstall/forbrukstall-utils';
import { sumNum } from 'src/app/utils/array-utils';
import { hasChanged } from 'src/app/utils/change-utils';

@Component({
  selector: 'app-kostnadstall-month',
  templateUrl: './month.component.html',
  styleUrls: ['./month.component.scss']
})
export class KostnadstallMonthComponent {
  @Input() valgtAnleggMaaned: AnleggMaaned;
  @Input() selectedDate: Date;

  toRoundNumber = toRoundNumber;
  selectedYear: number;
  isPlusskunde: boolean;
  stromFastbelop: number;
  stromForbrukbelop: number;
  inntektProd: number;
  stromTotal: number;
  nettleieFastbelop: number;
  nettleieEnergiledd: number;
  nettleieAvgifter: number;
  nettleieTotal: number;
  stromstotteTotal: number;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (hasChanged([changes.valgtAnleggMaaned, changes.selectedDate])) {
      this.getValues();
    }
  }

  getValues() {
    this.selectedYear = this.selectedDate?.getFullYear();
    this.isPlusskunde = this.valgtAnleggMaaned.plusskunde;
    const thisYearList = this.valgtAnleggMaaned.maanedVerdiList.filter(
      (x) => x.aar === this.selectedYear
    );
    this.stromForbrukbelop = sumNum(
      thisYearList.map((x) => x.belopKraft - x.fastbelopKraft)
    );
    this.stromFastbelop = sumNum(thisYearList.map((x) => x.fastbelopKraft));
    if (this.isPlusskunde) {
      this.inntektProd = sumNum(thisYearList.map((x) => -x.belopPlussverdi));
      this.stromTotal =
        this.stromFastbelop + this.stromForbrukbelop - this.inntektProd;
    } else {
      this.stromTotal = this.stromFastbelop + this.stromForbrukbelop;
    }

    this.nettleieFastbelop = sumNum(
      thisYearList.map((x) => x.fastbelopNettleie)
    );
    this.nettleieEnergiledd = sumNum(
      thisYearList.map((x) => x.belopNettleieEnergi)
    );
    this.nettleieAvgifter = sumNum(thisYearList.map((x) => x.avgifterNettleie));
    this.stromstotteTotal = sumNum(thisYearList.map((x) => x.stromstotte || 0));
    this.nettleieTotal =
      this.nettleieAvgifter +
      this.nettleieEnergiledd +
      this.nettleieFastbelop -
      Math.abs(this.stromstotteTotal);
  }
}
